/*
 * <product-card-slider>
 * product-card-custom の商品画像 (1枚目/2枚目) をスワイプ・ドットで切り替える。
 * CSS の scroll-snap でスワイプを担い、ここでは現在位置とドットを同期する。
 */
if (!customElements.get('product-card-slider')) {
  customElements.define(
    'product-card-slider',
    class ProductCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pvz-card__slides');
        this.slides = Array.from(this.querySelectorAll('.pvz-card__slide'));
        this.dots = Array.from(this.querySelectorAll('.pvz-card__dot'));

        if (!this.track || this.slides.length < 2) return;

        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (event) => {
            // 親リンクへの遷移を抑止してスライド切り替えのみ行う
            event.preventDefault();
            this.goTo(index);
          });
        });
      }

      goTo(index) {
        const slide = this.slides[index];
        if (slide) {
          this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }

      onScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = null;
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.setActive(index);
        });
      }

      setActive(index) {
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }
  );
}
